export default {
  "content": "<path d=\"M9.7 8.345a.2.2 0 01.3-.174l6.396 3.655a.2.2 0 010 .348L10 15.829a.2.2 0 01-.3-.174v-7.31z\" fill=\"#7B61FF\"/><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M4.928 4.929c3.906-3.906 10.238-3.905 14.143 0 3.905 3.905 3.905 10.237 0 14.142-3.905 3.905-10.237 3.905-14.143 0-3.905-3.905-3.905-10.237 0-14.142zm12.729 1.414A8.001 8.001 0 106.342 17.659 8.001 8.001 0 0017.657 6.343z\" fill=\"#7B61FF\"/>",
  "attrs": {
    "width": "24",
    "height": "24",
    "viewBox": "0 0 24 24",
    "fill": "none",
    "xmlns": "http://www.w3.org/2000/svg"
  }
};